import { Test } from "../_Test/Test.js";
const test = new Test();
test.sayHello();

console.log("Number of h2 headers is " + $("h2").length);

import { Popup } from "../mod_popups/mod_popups.js";
const popup = new Popup();
window.popup = popup;

import { Lead } from "../mod_lead/mod_lead.js";
const lead = new Lead();
window.lead = lead;

// // import { Przv_api } from "../mod_perezvoni/mod_perezvoni.js";
// const przv_api = new Przv_api();
// //window.przv_onEmail = przv_api.przv_onEmail;
// window.przv_onCall = przv_api.przv_onCall;

require("../mod_clinics/mod_clinics.js");
require("../mod_doctors/mod_doctors.js");
require("../mod_price/mod_price.js");
require("../mod_feedback/mod_feedback.js");
require("../mod_feedback2/mod_feedback2.js");
require("../mod_alert/mod_alert.js");

// window._calltouchChatClick = function(){
// 	$('[data-b24-crm-button-icon="openline"]').click();
// };

// function setHeaderPadding() {
// 	var headerTopHeight = $(".header__top").outerHeight();

// 	$(".header-index").css("padding-top", headerTopHeight);
// 	$(".header-inner").css("padding-top", headerTopHeight);
// };
// setHeaderPadding();

//require("jquery.maskedinput/src/jquery.maskedinput.js");
//const clinics = new Clinics();
//window.clinics = clinics;

//COOOKIE//
$(document).ready(function() {
	// Проверяем, было ли ранее дано согласие
	if (getCookie("cookie_consent") !== "true") {
		// Только если cookie нет — показываем
		if (getCookie("cookie_consent") !== "true") {
			$("#cookie-consent").css("display", "flex");
		}
	}

	// Обработчик события клика на кнопку "Принять"
	$("#accept-cookies").click(function() {
		// Сохраняем согласие пользователя в cookie на 365 дней
		const expires = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toUTCString();
		document.cookie = "cookie_consent=true; expires=" + expires + "; path=/";
		hideCookieConsent();
	});
});

// Функция для скрытия блока с соглашением
function hideCookieConsent() {
	$("#cookie-consent").hide();
}

function setCookie(name, value, expires, path = '/', domain = '', secure = false) {
	expires instanceof Date ? expires = expires.toGMTString() : typeof (expires) == 'number' && (expires = (new Date(+(new Date) + expires * 1e3)).toGMTString());
	var r = [name + "=" + escape(value)], s, i;
	for (i in s = { expires: expires, path: path, domain: domain }) {
		s[i] && r.push(i + "=" + s[i]);
	}
	return secure && r.push("secure"), document.cookie = r.join(";"), true;
}

// Функция для получения значения cookie
function getCookie(name) {
	var nameEQ = name + "=";
	var ca = document.cookie.split(';');
	for(var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) === ' ') c = c.substring(1, c.length);
		if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
	}
	return undefined;
}
//COOKIE//

$('input[name=str_phone]').mask("+7 (999) 999-99-99");

$(".sertificates__list").slick({
	nextArrow: '<button type="button" class="slider__arrow .bvi-no-styles slider__arrow-right slider__arrow-right--certificates" aria-label="Previous"></button>',
	prevArrow: '<button type="button" class="slider__arrow .bvi-no-styles slider__arrow-left slider__arrow-left--certificates" aria-label="Next"></button>',
	infinite: true,
	speed: 300,
	slidesToShow: 1,
	slidesToScroll: 1,
	centerMode: true,
	variableWidth: true
});

var sliderMoved = false;

$(window).scroll(function() {
	let pos = $('.header-actions').height()
	if ($(this).scrollTop() > pos) {
		$('.header__top').addClass('scrolled');
		$('.header-actions').addClass('scrolled');
	} else {
		$('.header__top').removeClass('scrolled');
		$('.header-actions').removeClass('scrolled');
	}

	if ($(this).scrollTop() > 1000) {
		$('.to-top').addClass('scrolled');
	} else {
		$('.to-top').removeClass('scrolled');
	}

	if ($(this).scrollTop() > 0) {
		$('.special-btn').addClass('scrolled');
	} else {
		$('.special-btn').removeClass('scrolled');
	}

	let v = $(window).height();
	let s = $(window).scrollTop();

	if ($('.sertificates').length) {
		if ((s > $('.sertificates').offset().top + $('.sertificates__list').height() - v) && !sliderMoved && $(".sertificates__list").hasClass('slick-initialized') && $(window).width() >= 1024) {
			$(".sertificates__list").slick('slickNext');
			sliderMoved = true;
		}
	}

});


$(".doctors__list").slick({
	dots: true,
	nextArrow: '<button type="button" class="slider__arrow .bvi-no-styles slider__arrow-right slider__arrow-right--doctors-main" aria-label="Previous"></button>',
	prevArrow: '<button type="button" class="slider__arrow .bvi-no-styles slider__arrow-left slider__arrow-left--doctors-main" aria-label="Next"></button>',
	infinite: true,
	speed: 300,
	dotsClass: 'slider-dots slider-dots__main-doctors',
	slidesToShow: 1,
	slidesToScroll: 1,
	variableWidth: true,
	responsive: [{
			breakpoint: 1366,
			settings: {
				dots: true,
				nextArrow: '<button type="button" class="slider__arrow .bvi-no-styles slider__arrow-right slider__arrow-right--doctors-main" aria-label="Previous"></button>',
				prevArrow: '<button type="button" class="slider__arrow .bvi-no-styles slider__arrow-left slider__arrow-left--doctors-main" aria-label="Next"></button>',
				infinite: true,
				speed: 300,
				dotsClass: 'slider-dots slider-dots__main-doctors',
				slidesToShow: 3,
				slidesToScroll: 3,
				variableWidth: true,
				adaptiveHeight: true
			}
		},
		{
			breakpoint: 1024,
			settings: {
				dots: true,
				nextArrow: '<button type="button" class="slider__arrow .bvi-no-styles slider__arrow-right slider__arrow-right--doctors-main" aria-label="Previous"></button>',
				prevArrow: '<button type="button" class="slider__arrow .bvi-no-styles slider__arrow-left slider__arrow-left--doctors-main" aria-label="Next"></button>',
				infinite: true,
				speed: 300,
				dotsClass: 'slider-dots slider-dots__main-doctors',
				slidesToShow: 1,
				slidesToScroll: 1,
				variableWidth: true,
				adaptiveHeight: true
			}
		}
	]
});

$(".header-actions__slider").slick({
	dots: true,
	arrows: false,
	infinite: true,
	lazyLoad: 'ondemand',
	slidesToShow: 1,
	slidesToScroll: 1,
	autoplay: true,
	autoplaySpeed: 5000,
});

$(".impl-doctors__list").slick({
	dots: true,
	nextArrow: '<button type="button" class="slider__arrow .bvi-no-styles slider__arrow-right slider__arrow-right--doctors-main" aria-label="Previous"></button>',
	prevArrow: '<button type="button" class="slider__arrow .bvi-no-styles slider__arrow-left slider__arrow-left--doctors-main" aria-label="Next"></button>',
	infinite: true,
	speed: 300,
	dotsClass: 'slider-dots slider-dots__main-doctors',
	slidesToShow: 1,
	slidesToScroll: 1,
	variableWidth: true,
	responsive: [{
			breakpoint: 1366,
			settings: {
				dots: true,
				nextArrow: '<button type="button" class="slider__arrow .bvi-no-styles slider__arrow-right slider__arrow-right--doctors-main" aria-label="Previous"></button>',
				prevArrow: '<button type="button" class="slider__arrow .bvi-no-styles slider__arrow-left slider__arrow-left--doctors-main" aria-label="Next"></button>',
				infinite: true,
				speed: 300,
				dotsClass: 'slider-dots slider-dots__main-doctors',
				slidesToShow: 3,
				slidesToScroll: 3,
				variableWidth: true,
				adaptiveHeight: true
			}
		},
		{
			breakpoint: 1024,
			settings: {
				dots: true,
				nextArrow: '<button type="button" class="slider__arrow .bvi-no-styles slider__arrow-right slider__arrow-right--doctors-main" aria-label="Previous"></button>',
				prevArrow: '<button type="button" class="slider__arrow .bvi-no-styles slider__arrow-left slider__arrow-left--doctors-main" aria-label="Next"></button>',
				infinite: true,
				speed: 300,
				dotsClass: 'slider-dots slider-dots__main-doctors',
				slidesToShow: 1,
				slidesToScroll: 1,
				variableWidth: true,
				adaptiveHeight: true
			}
		}
	]
});

$(".reviews .reviews__list").slick({
	dots: true,
	nextArrow: '<button type="button" class="slider__arrow .bvi-no-styles slider__arrow-right slider__arrow-right--reviews" aria-label="Previous"></button>',
	prevArrow: '<button type="button" class="slider__arrow .bvi-no-styles slider__arrow-left slider__arrow-left--reviews" aria-label="Next"></button>',
	infinite: true,
	speed: 300,
	dotsClass: 'slider-dots slider-dots__main-reviews',
	slidesToShow: 1,
	slidesToScroll: 1,
	// fade: true,
	centerMode: true,
	variableWidth: true,
	adaptiveHeight: true,
	responsive: [{
			breakpoint: 1366,
			settings: {
				dots: true,
				nextArrow: '<button type="button" class="slider__arrow .bvi-no-styles slider__arrow-right slider__arrow-right--reviews" aria-label="Previous"></button>',
				prevArrow: '<button type="button" class="slider__arrow .bvi-no-styles slider__arrow-left slider__arrow-left--reviews" aria-label="Next"></button>',
				infinite: true,
				speed: 300,
				dotsClass: 'slider-dots slider-dots__main-reviews',
				slidesToShow: 1,
				slidesToScroll: 1,
				variableWidth: true,
				adaptiveHeight: true
			}
		},
		{
			breakpoint: 1024,
			settings: {
				dots: true,
				nextArrow: '<button type="button" class="slider__arrow .bvi-no-styles slider__arrow-right slider__arrow-right--reviews" aria-label="Previous"></button>',
				prevArrow: '<button type="button" class="slider__arrow .bvi-no-styles slider__arrow-left slider__arrow-left--reviews" aria-label="Next"></button>',
				infinite: true,
				speed: 300,
				dotsClass: 'slider-dots slider-dots__main-reviews',
				slidesToShow: 1,
				slidesToScroll: 1,
				variableWidth: true,
				adaptiveHeight: true
			}
		}
	]
});

$(".services-one__doctors-list").slick({
	dots: true,
	infinite: true,
	nextArrow: '<button type="button" class="slider__arrow slider__arrow-right slider__arrow-right--doctors-service" aria-label="Previous"></button>',
	prevArrow: '<button type="button" class="slider__arrow slider__arrow-left slider__arrow-left--doctors-service" aria-label="Next"></button>',
	speed: 300,
	dotsClass: 'slider-dots slider-dots__service-doctors',
	slidesToShow: 1,
	slidesToScroll: 1,
	variableWidth: true,
	responsive: [{
			breakpoint: 1366,
			settings: {
				dots: true,
				infinite: true,
				nextArrow: '<button type="button" class="slider__arrow slider__arrow-right slider__arrow-right--doctors-service" aria-label="Previous"></button>',
				prevArrow: '<button type="button" class="slider__arrow slider__arrow-left slider__arrow-left--doctors-service" aria-label="Next"></button>',
				speed: 300,
				dotsClass: 'slider-dots slider-dots__service-doctors',
				slidesToShow: 1,
				slidesToScroll: 1
			}
		},
		{
			breakpoint: 1024,
			settings: {
				dots: true,
				infinite: true,
				nextArrow: '<button type="button" class="slider__arrow slider__arrow-right slider__arrow-right--doctors-service" aria-label="Previous"></button>',
				prevArrow: '<button type="button" class="slider__arrow slider__arrow-left slider__arrow-left--doctors-service" aria-label="Next"></button>',
				speed: 300,
				dotsClass: 'slider-dots slider-dots__service-doctors',
				slidesToShow: 1,
				slidesToScroll: 1,
				variableWidth: true,
				adaptiveHeight: true
			}
		}
	]
});

$(".main-services__doctors-list").slick({
	dots: true,
	infinite: true,
	nextArrow: '<button type="button" class="slider__arrow slider__arrow-right slider__arrow-right--doctors-services" aria-label="Previous"></button>',
	prevArrow: '<button type="button" class="slider__arrow slider__arrow-left slider__arrow-left--doctors-services" aria-label="Next"></button>',
	speed: 300,
	dotsClass: 'slider-dots slider-dots__services-doctors',
	slidesToShow: 3,
	slidesToScroll: 3,
	variableWidth: true,
	adaptiveHeight: true,
	responsive: [{
		breakpoint: 1024,
		settings: {
			dots: true,
			infinite: true,
			nextArrow: '<button type="button" class="slider__arrow slider__arrow-right slider__arrow-right--doctors-services" aria-label="Previous"></button>',
			prevArrow: '<button type="button" class="slider__arrow slider__arrow-left slider__arrow-left--doctors-services" aria-label="Next"></button>',
			speed: 300,
			dotsClass: 'slider-dots slider-dots__services-doctors',
			slidesToShow: 1,
			slidesToScroll: 1,
			variableWidth: true,
			adaptiveHeight: true
		}
	}]
});

$(".offers__list-main").slick({
	dots: true,
	nextArrow: '<button type="button" class="slider__arrow .bvi-no-styles slider__arrow-right slider__arrow-right--main-offers" aria-label="Previous"></button>',
	prevArrow: '<button type="button" class="slider__arrow .bvi-no-styles slider__arrow-left slider__arrow-left--main-offers" aria-label="Next"></button>',
	dotsClass: 'slider-dots slider-dots__main-offers',
	infinite: true,
	speed: 300,
	slidesToShow: 1,
	slidesToScroll: 1,
	variableWidth: true,
	adaptiveHeight: true,
	centerMode: true
});

$(".helpful-slider__list").slick({
	dots: true,
	infinite: true,
	nextArrow: '<button type="button" class="slider__arrow slider__arrow-right slider__arrow-right--helpful" aria-label="Previous"></button>',
	prevArrow: '<button type="button" class="slider__arrow slider__arrow-left slider__arrow-left--helpful" aria-label="Next"></button>',
	dotsClass: 'slider-dots slider-dots__helpful',
	variableWidth: true,
	adaptiveHeight: true,
	centerMode: true,
	responsive: [{
			breakpoint: 1366,
			settings: {
				infinite: true,
				dots: true,
				nextArrow: '<button type="button" class="slider__arrow slider__arrow-right slider__arrow-right--helpful" aria-label="Previous"></button>',
				prevArrow: '<button type="button" class="slider__arrow slider__arrow-left slider__arrow-left--helpful" aria-label="Next"></button>',
				dotsClass: 'slider-dots slider-dots__helpful',
				slidesToShow: 2,
				slidesToScroll: 2,
				variableWidth: true,
				centerMode: false,
				adaptiveHeight: true
			}
		},
		{
			breakpoint: 1024,
			settings: {
				infinite: true,
				dots: true,
				nextArrow: '<button type="button" class="slider__arrow slider__arrow-right slider__arrow-right--helpful" aria-label="Previous"></button>',
				prevArrow: '<button type="button" class="slider__arrow slider__arrow-left slider__arrow-left--helpful" aria-label="Next"></button>',
				dotsClass: 'slider-dots slider-dots__helpful',
				slidesToShow: 1,
				slidesToScroll: 1,
				variableWidth: true,
				adaptiveHeight: true,
				centerMode: true
			}
		}
	]
});

$(".impl-feedback__slider").slick({
	dots: true,
	infinite: true,
	nextArrow: '<button type="button" class="slider__arrow slider__arrow-right slider__arrow-right--impl-feedback" aria-label="Previous"></button>',
	prevArrow: '<button type="button" class="slider__arrow slider__arrow-left slider__arrow-left--impl-feedback" aria-label="Next"></button>',
	dotsClass: 'slider-dots slider-dots__impl-feedback',
	slidesToShow: 1,
	slidesToScroll: 1,
	variableWidth: true,
	adaptiveHeight: true,
	draggable: false,
	swipe: false,
	responsive: [{
		breakpoint: 1024,
		settings: {
			infinite: true,
			dots: true,
			nextArrow: '<button type="button" class="slider__arrow slider__arrow-right slider__arrow-right--impl-feedback" aria-label="Previous"></button>',
			prevArrow: '<button type="button" class="slider__arrow slider__arrow-left slider__arrow-left--impl-feedback" aria-label="Next"></button>',
			dotsClass: 'slider-dots slider-dots__impl-feedback',
			slidesToShow: 1,
			slidesToScroll: 1,
			variableWidth: true,
			adaptiveHeight: true,
			centerMode: true
		}
	}]
});

$(".clinics-page__image-list").slick({
	dots: true,
	nextArrow: '<button type="button" class="slider__arrow slider__arrow-right slider__arrow-right--image-list" aria-label="Previous"></button>',
	prevArrow: '<button type="button" class="slider__arrow slider__arrow-left slider__arrow-left--image-list" aria-label="Next"></button>',
	infinite: true,
	speed: 300,
	dotsClass: 'slider-dots slider-dots__image-list',
	slidesToShow: 1,
	slidesToScroll: 1,
	centerMode: true,
	variableWidth: true,
	adaptiveHeight: true,
	responsive: [{
			breakpoint: 1366,
			settings: {
				dots: true,
				nextArrow: '<button type="button" class="slider__arrow slider__arrow-right slider__arrow-right--image-list" aria-label="Previous"></button>',
				prevArrow: '<button type="button" class="slider__arrow slider__arrow-left slider__arrow-left--image-list" aria-label="Next"></button>',
				infinite: true,
				speed: 300,
				dotsClass: 'slider-dots slider-dots__image-list',
				slidesToShow: 1,
				slidesToScroll: 1,
				centerMode: true,
				variableWidth: true,
				adaptiveHeight: true
			}
		},
		{
			breakpoint: 1024,
			settings: {
				dots: true,
				nextArrow: '<button type="button" class="slider__arrow slider__arrow-right slider__arrow-right--image-list" aria-label="Previous"></button>',
				prevArrow: '<button type="button" class="slider__arrow slider__arrow-left slider__arrow-left--image-list" aria-label="Next"></button>',
				infinite: true,
				speed: 300,
				dotsClass: 'slider-dots slider-dots__image-list',
				slidesToShow: 1,
				slidesToScroll: 1,
				centerMode: true,
				variableWidth: true,
				adaptiveHeight: true
			}
		}
	]
});

$(document).ready(function() {
    let slickInitialized = false; // Флаг, чтобы избежать зацикливания

    $('.clinics-list').on('init', function() {
        slickInitialized = true; // Слайдер инициализирован
    });

    $('.clinics-list').slick({
        infinite: false,
        dots: false,
        speed: 300,
        nextArrow: '<button type="button" class="slider__arrow slider__arrow-right slider__arrow-right--clinics" aria-label="Next"></button>',
        prevArrow: '<button type="button" class="slider__arrow slider__arrow-left slider__arrow-left--clinics" aria-label="Previous"></button>',
        dotsClass: 'slider-dots slider-dots__clinics',
        slidesToShow: 3,
        slidesToScroll: 1,
        variableWidth: true,
        centerMode: false,
        initialSlide: 0,
        rtl: false,
        responsive: [{
            breakpoint: 1024,
            settings: "unslick"
        }]
    });

    function fixSlickLayout() {
        if (!slickInitialized || !$('.clinics-list').hasClass('slick-initialized')) return;

        let track = document.querySelector('.clinics-list .slick-track');
        let list = document.querySelector('.clinics-list .slick-list');

        if (track && list) {
            list.style.overflow = 'hidden';
            list.style.position = 'relative';
            list.style.width = '100%';

            track.style.display = 'flex';
            track.style.flexWrap = 'nowrap';
            track.style.alignItems = 'stretch';
            track.style.width = '100%';
            track.style.transform = 'translate3d(0px, 0px, 0px)'; // Главное исправление смещения
            track.style.left = '0px';
            track.style.position = 'relative';
        }

        document.querySelectorAll('.clinics-list .slick-slide').forEach(el => {
            el.style.flex = '0 0 auto';
            el.style.width = 'auto';
            el.style.maxWidth = '100%';
            el.style.display = 'block';
        });

        setTimeout(() => $('.clinics-list').slick('setPosition'), 100);
    }

    $('.clinics-list').on('afterChange', function() {
        fixSlickLayout();
    });

    $(window).on('resize', function() {
        if (!slickInitialized) return;
        setTimeout(fixSlickLayout, 200);
    });

    setTimeout(() => {
        fixSlickLayout();
        console.log('✅ ФИНАЛЬНЫЙ ФИКС Slick применен');
    }, 500);
});


// $(document).ready(function() {
// 	var swiper = new Swiper('.clinics-swiper', {
// 		loop: false,
// 		slidesPerView: "1",
// 		spaceBetween: 20,
// 		navigation: {
// 			nextEl: '.slider__arrow-right--clinics',
// 			prevEl: '.slider__arrow-left--clinics',
// 		},
// 		breakpoints: {
// 			576: {
// 				slidesPerView: "2",
// 				spaceBetween: 20,
// 			},
// 			1024: {
// 				slidesPerView: "3",
// 				spaceBetween: 20,
// 			},
// 			// 1440: {
// 			// 	slidesPerView: "4",
// 			// 	spaceBetween: 20,
// 			// },
// 		},
// 	});
// });

$(".service-types__slider").slick({
	dots: true,
	nextArrow: '<button type="button" class="slider__arrow slider__arrow-right slider__arrow-right--prot-types" aria-label="Previous"></button>',
	prevArrow: '<button type="button" class="slider__arrow slider__arrow-left slider__arrow-left--prot-types" aria-label="Next"></button>',
	infinite: true,
	speed: 300,
	dotsClass: 'slider-dots slider-dots__prot-types',
	variableWidth: true,
	adaptiveHeight: true,
	slidesToShow: 1,
	slidesToScroll: 1,
	responsive: [{
		breakpoint: 1024,
		settings: {
			centerMode: true
		}
	}]
});

$(".portfolio-one__slider").slick({
	dots: true,
	nextArrow: '<button type="button" class="slider__arrow slider__arrow-right slider__arrow-right--portfolio" aria-label="Previous"></button>',
	prevArrow: '<button type="button" class="slider__arrow slider__arrow-left slider__arrow-left--portfolio" aria-label="Next"></button>',
	infinite: true,
	speed: 300,
	dotsClass: 'slider-dots slider-dots__portfolio',
	adaptiveHeight: true
});

$(".rate__item-slider-list").slick({
	nextArrow: '<button type="button" class="slider__arrow slider__arrow-right slider__arrow-right--rate" aria-label="Previous"></button>',
	prevArrow: '<button type="button" class="slider__arrow slider__arrow-left slider__arrow-left--rate" aria-label="Next"></button>',
	infinite: true,
	speed: 300,
	slidesToShow: 4,
	slidesToScroll: 1,
	variableWidth: true,
	adaptiveHeight: true,
	responsive: [{
			breakpoint: 1366,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 1
			}
		},
		{
			breakpoint: 1024,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				variableWidth: false
			}
		}
	]
});

$(".rate-other__list").slick({
	nextArrow: '<button type="button" class="slider__arrow slider__arrow-right slider__arrow-right--rate-other" aria-label="Previous"></button>',
	prevArrow: '<button type="button" class="slider__arrow slider__arrow-left slider__arrow-left--rate-other" aria-label="Next"></button>',
	infinite: true,
	speed: 300,
	centerMode: true,
	variableWidth: true
});

$(".rate-media__list").slick({
	dots: true,
	dotsClass: 'slider-dots slider-dots__rate-media',
	nextArrow: '<button type="button" class="slider__arrow slider__arrow-right slider__arrow-right--rate-media" aria-label="Previous"></button>',
	prevArrow: '<button type="button" class="slider__arrow slider__arrow-left slider__arrow-left--rate-media" aria-label="Next"></button>',
	infinite: false,
	autoplay: true,
	speed: 300,
	slidesToShow: 2,
	slidesToScroll: 1,
	variableWidth: true,
	adaptiveHeight: true,
	responsive: [{
			breakpoint: 1366,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 1
			}
		},
		{
			breakpoint: 1024,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				variableWidth: false
			}
		}
	]
});

$(".reviews-video__list").slick({
	nextArrow: '<button type="button" class="slider__arrow slider__arrow-right slider__arrow-right--video-reviews" aria-label="Previous"></button>',
	prevArrow: '<button type="button" class="slider__arrow slider__arrow-left slider__arrow-left--video-reviews" aria-label="Next"></button>',
	dots: true,
	dotsClass: 'slider-dots slider-dots__video-reviews',
});


$(".doctor__slider-list").slick({
	nextArrow: '<button type="button" class="slider__arrow slider__arrow-right slider__arrow-right--doctor-slider" aria-label="Previous"></button>',
	prevArrow: '<button type="button" class="slider__arrow slider__arrow-left slider__arrow-left--doctor-slider" aria-label="Next"></button>',
	dots: true,
	dotsClass: 'slider-dots slider-dots__doctor-slider',
	infinite: false,
	slidesToShow: 3,
	slidesToScroll: 1,
	variableWidth: true,
	responsive: [{
		breakpoint: 1024,
		settings: {
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite: true,
			centerMode: true,
		}
	}]
});

$('form select').each(function() {
	$(this).select2({
		placeholder: $(this).attr('placeholder'),
		width: '100%',
		containerCssClass: 'form__select',
		dropdownCssClass: 'form__dropdown',
		minimumResultsForSearch: -1
	});
});

// $('.impl-feedback__slider-photos a').colorbox();

$('a[href^="#"]').not('.popup-link').click(function() {
	let elementClick = $(this).attr("href").replace(/#/, '');
	if (elementClick && $('a[name=' + elementClick + ']').length) {
		let destination = $('a[name=' + elementClick + ']').offset().top;
		$('html, body').animate({ scrollTop: destination }, 1100);
		return false;
	}
});

$(document).ready(function() {
	if (window.location.hash.match(/#.+/)) {
		let elementClick = window.location.hash.replace(/.*#/, '');
		if (elementClick && $('a[name=' + elementClick + ']').length) {
			let destination = $('a[name=' + elementClick + ']').offset().top;
			$(window).scrollTop(destination);
		}
	}
});

function setcookie(name, value, expires, path, domain, secure) { // Send a cookie
	//
	// +   original by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)

	expires instanceof Date ? expires = expires.toGMTString() : typeof(expires) == 'number' && (expires = (new Date(+(new Date) + expires * 1e3)).toGMTString());
	var r = [name + "=" + escape(value)],
		s, i;
	for (i in s = { expires: expires, path: path, domain: domain }) {
		s[i] && r.push(i + "=" + s[i]);
	}
	return secure && r.push("secure"), document.cookie = r.join(";"), true;
}

// возвращает cookie если есть или undefined
function getcookie(name) {
	var matches = document.cookie.match(new RegExp(
		"(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
	))
	return matches ? decodeURIComponent(matches[1]) : undefined
}

document.addEventListener("DOMContentLoaded", function() {
	if (window.location.pathname.includes("akcii")) {
		var socialBlock = document.querySelector(".footer__appointment");
		if (socialBlock) {
			socialBlock.style.display = "none";
		}
	}
});

// TABS
$(".tabs__content")
	.children(".tabs__item")
	.not(":first")
	.hide();
$(".tabs__nav-btn").click(function() {
		$(".tabs__nav-btn")
			.removeClass("active")
			.eq($(this).index())
			.addClass("active");
		$(".tabs__item")
			.hide()
			.eq($(this).index())
			.fadeIn();
	})
	.eq(0)
	.addClass("active");

// PUBTABS
$(".pubtabs__content")
	.children(".pubtabs__item")
	.not(":first")
	.hide();
$(".pubtabs__nav-btn").click(function() {
		$(".pubtabs__nav-btn")
			.removeClass("active")
			.eq($(this).index())
			.addClass("active");
		$(".pubtabs__item")
			.hide()
			.eq($(this).index())
			.fadeIn();
	})
	.eq(0)
	.addClass("active");

// PERSTABS
$(".perstabs__content")
	.children(".perstabs__item")
	.not(":first")
	.hide();
$(".perstabs__nav-btn").click(function() {
		$(".perstabs__nav-btn")
			.removeClass("active")
			.eq($(this).index())
			.addClass("active");
		$(".perstabs__item")
			.hide()
			.eq($(this).index())
			.fadeIn();
	})
	.eq(0)
	.addClass("active");

// $(".tabs__content")
// 	.children(".tabs__item:not(:first-of-type)")
// 	.hide();
// $(".tabs__nav-btn").click(function() {
// 	$(this).siblings(".tabs__nav-btn").removeClass("active");
// 	$(this).siblings(".tabs__nav-btn").eq($(this).index()).addClass("active");
// 	$(this).parent(".tabs__nav").siblings(".tabs__content").children(".tabs__item")
// 		.hide()
// 		.eq($(this).index())
// 		.fadeIn();
// })
// .eq(0)
// .addClass("active");

// Попап о новом годе
$('.new-year__close').click(function() {
	$('.new-year').slideUp();
});

// Попап о КОВИДе
// $('.covid__close').click(function(){
// 	$('.covid').slideUp();
// 	setcookie('covid_showed', 1, 60*60*24*2, '/');
// })

// if (location.pathname != '/')
// {
// 	if (getcookie('covid_showed'))
// 		$('.covid').hide();
// }

var actual_status_hide_content = true

function show_hidden_content(array) {
	for (let i = 0; i < array.length; i++) {
		$("#" + array[i]).toggle();
	}
	if (actual_status_hide_content)
		$('#edit-this-text-komb-brek').text('Скрыть');
	else
		$('#edit-this-text-komb-brek').text('Показать ещё');
	actual_status_hide_content = !actual_status_hide_content
}

$(".reviews__item-text-wrapper").each(function() {
	var $minHeight = 159;
	if ($(this).height() > $minHeight) {
		$(this).parent(".reviews__content").addClass("active");
	}
});

$(function() {
	$('.to-down').click(function() {
		$(this).siblings('.reviews__item-text-wrapper').toggleClass('wrapper-active');
	});
});


$(function() {
	$('.to-down').click(function() {
		$(this).toggleClass('to-down-active');
	});
});


$('.to-down').click(function() {
	if (!$(this).data('status')) {
		$(this).html('Скрыть');
		$(this).data('status', true);
	} else {
		$(this).html('Читать далее');
		$(this).data('status', false);
	}
});

// $('.header-main__info-search-submit').click(function() {
// 	$('.header-main__info-search-input').addClass('open-search');
// 	$('.header-main__info-search-input-search').addClass('open-search-input');

// });

// $(".header-main__info-search-submit").click(function(e) {
// 	// e.preventDefault();
// 	$(this).removeClass('header-main__info-search-submit-active');
// 	$(this).toggleClass('header-main__info-search-submit-active');
// 	$(".header-main__info-search-input").removeClass('open-search');
// 	$(".header-main__info-search-input").toggleClass('open-search');
// 	$(".header-main__info-search-input-search").removeClass('open-search-input');
// 	$(".header-main__info-search-input-search").toggleClass('open-search-input');
// });


$(".header-main__info-search-submit").click(function () {
	$(this).toggleClass("header-main__info-search-submit-active");
	$(".header-main__info-search-close").toggleClass('header-main__info-search-close-active');
	$(".header-main__info-search-input").toggleClass('open-search');
	$(".header-main__info-search-input-search").toggleClass('open-search-input');
});

$(".header-main__info-search-close").click(function () {
	$(this).toggleClass("header-main__info-search-close-active");
	$(".header-main__info-search-submit").toggleClass("header-main__info-search-submit-active");
	$(".header-main__info-search-input").toggleClass('open-search');
	$(".header-main__info-search-input-search").toggleClass('open-search-input');
});
